import styled from 'styled-components';

import { mediaSmallOrTiny } from '@xing-com/layout-tokens';

import { FollowButton as InnerFollowButton } from './follow-button/follow-button';

export const FollowButton = styled(InnerFollowButton)`
  @media ${mediaSmallOrTiny} {
    flex: 1;
  }
`;
